import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useDownloadOpenContracts } from "@/lib/api/otc";
import { useBearStore } from "../ContractForm";
import { ReportCard, ReportDownloadLink } from "./ReportCard";

/**
 * Open Contract Report — no own filters. Runs against the global
 * contract_filters that drive the Open Contracts table.
 */
export function OpenContractReportCard() {
  const { toast } = useToast();
  const downloadDataLinkFunc = useDownloadOpenContracts();
  const contract_filters = useBearStore((state) => state.contract_filters.filters);
  const [link, setLink] = useState<string | undefined>(undefined);
  const [isDownloading, setIsDownloading] = useState(false);

  const onGenerate = async () => {
    if (isDownloading) return;
    setLink(undefined);
    setIsDownloading(true);

    const result = await downloadDataLinkFunc({ filters: contract_filters });

    if (!result.success) {
      toast({ title: "Failed to generate", description: "" });
    } else {
      setLink(result.data.link);
    }

    setIsDownloading(false);
  };

  return (
    <ReportCard
      title="Open Contract Report"
      description="Download all currently open OTC contracts."
      isDownloading={isDownloading}
      onGenerate={onGenerate}
      hasResults={!!link}
      linkContent={link ? <ReportDownloadLink href={link} label="Download Report" /> : null}
    />
  );
}
